import React from 'react';
import WeddingBudgetBuilder from '../features/weddingBudgetBuilder';

export default function WeddingCostCalculator() {
  return (
    <div className="bg-[#fafbfc] min-h-screen flex flex-col">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#fff8f3] via-[#f7e6df] to-[#e6f7f7] py-6 px-4 text-center flex flex-col items-center justify-center min-h-[300px]">
        <img 
          src="/images/tulum-1600.jpg" 
          alt="Tulum Wedding Beach" 
          className="absolute inset-0 w-full h-full object-cover object-center opacity-60 pointer-events-none select-none" 
          style={{ zIndex: 0 }}
        />
        {/* Dark overlay for contrast */}
        <div className="absolute inset-0 bg-black/60" style={{zIndex: 1}} />
        <div className="relative z-10 max-w-2xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold mb-2 text-white drop-shadow-lg">Plan Your Dream Wedding</h1>
          <div className="text-3xl md:text-4xl font-playfair font-bold mb-4 text-[#ffe9b3] drop-shadow-lg">US vs. Mexico Cost Calculator</div>
          <p className="text-lg md:text-xl text-white mb-0 max-w-2xl mx-auto drop-shadow">See how much you can save by celebrating your special day in Mexico. Get a personalized budget breakdown in minutes.</p>
        </div>
      </section>
      {/* Calculator Section */}
      <section id="calculator" className="max-w-3xl mx-auto w-full px-2 py-1">
        <WeddingBudgetBuilder />
        <div className="flex flex-col md:flex-row gap-2 justify-center mt-2">
          <a href="/faq" className="text-[#bfa76a] font-semibold underline hover:text-[#a68d5d] transition">See Frequently Asked Questions</a>
          <a href="/guest-experience-calculator" className="text-[#bfa76a] font-semibold underline hover:text-[#a68d5d] transition">Try the Guest Experience Calculator</a>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="bg-white py-16 px-4 border-t border-[#ececec]">
        <h2 className="text-3xl font-playfair font-bold mb-8 text-[#181c24] text-center">Why Choose Mexico for Your Wedding?</h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-10">
          <div className="flex flex-col items-center text-center">
            <span className="text-4xl mb-2">🏝️</span>
            <h3 className="font-semibold text-lg mb-2">Stunning Venues</h3>
            <p className="text-[#888]">From beaches to haciendas, Mexico offers breathtaking backdrops for every style.</p>
          </div>
          <div className="flex flex-col items-center text-center">
            <span className="text-4xl mb-2">💸</span>
            <h3 className="font-semibold text-lg mb-2">Exceptional Value</h3>
            <p className="text-[#888]">Enjoy luxury experiences and world-class service at a fraction of US prices.</p>
          </div>
          <div className="flex flex-col items-center text-center">
            <span className="text-4xl mb-2">🎉</span>
            <h3 className="font-semibold text-lg mb-2">Unforgettable Experiences</h3>
            <p className="text-[#888]">Unique culture, cuisine, and hospitality make your celebration truly memorable.</p>
          </div>
        </div>
        {/* Testimonials & Gallery Placeholder */}
        <div className="flex flex-col md:flex-row gap-8 max-w-5xl mx-auto mb-10">
          <div className="flex-1 bg-[#fafbfc] rounded-xl p-6 shadow text-left">
            <h4 className="font-bold text-[#bfa76a] mb-2">"Our Mexico wedding was magical and affordable!"</h4>
            <p className="text-[#181c24]">- Emily & Carlos</p>
          </div>
          <div className="flex-1 bg-[#fafbfc] rounded-xl p-6 shadow text-left">
            <h4 className="font-bold text-[#bfa76a] mb-2">"The venues and service exceeded all expectations."</h4>
            <p className="text-[#181c24]">- Priya & Sam</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-4 justify-center mb-8">
          <img src="/images/beachkiss.jpg" alt="Mexico Wedding" className="w-40 h-28 object-cover rounded-lg shadow" />
          <img src="/images/hacienda.jpg" alt="Hacienda Venue" className="w-40 h-28 object-cover rounded-lg shadow" />
          <img src="/images/flowers.jpg" alt="Wedding Flowers" className="w-40 h-28 object-cover rounded-lg shadow" />
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#bfa76a] py-12 px-4 text-center">
        <h2 className="text-3xl font-playfair font-bold mb-4 text-white">Ready to Plan Your Dream Wedding in Mexico?</h2>
        <a href="/contact" className="inline-block bg-white text-[#bfa76a] font-bold py-4 px-10 rounded-full text-lg shadow hover:bg-[#f3e6c6] transition-all">Get Your Personalized Proposal</a>
      </section>
    </div>
  );
} 